import React, { useState } from "react";
import Modal from "./UI/modal";
import SearchInput from "./UI/SearchInput";
import { Input } from "./UI/input";

const components = [
  { type: "TABS", name: "Tabs", category: "UI", tabs: [] },
  { type: "TEAM_STATS", name: "Team Stats", category: "Data" },
  {
    type: "GRAPHIC",
    name: "Match ID",
    label: "Match ID",
    category: "Graphics",
  },
  {
    type: "GRAPHIC",
    name: "Match ID",
    label: "Match ID",
    category: "Graphics",
  },
  {
    type: "GRAPHIC",
    name: "Match ID",
    label: "Match ID",
    category: "Graphics",
  },
  {
    type: "GRAPHIC",
    name: "Match ID",
    label: "Match ID",
    category: "Graphics",
  },
  {
    type: "GRAPHIC",
    name: "Match ID",
    label: "Match ID",
    category: "Graphics",
  },
];
function Components({ open, setOpen, onSave }) {
  const [search, setSearch] = useState("");
  const [selectedItem, setSelectedItem] = useState();
  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="flex flex-col max-h-[80vh]">
        <div className="flex">
          <div className="border-r-2 border-white/20 p-1">
            <SearchInput label={"Find component..."} onSearch={setSearch} />
            <ul className="flex flex-col max-h-[60vh] overflow-y-auto">
              {components
                ?.filter((n) => {
                  if (search === "") {
                    return n.name && true;
                  }
                  let reg = new RegExp(search, "i");
                  return n.name && n.name?.search(reg) > -1;
                })
                ?.map((item) => {
                  return (
                    <li
                      key={item.id}
                      data-active={selectedItem?.id === item?.id ? true : null}
                      className="pt-1 pb-1 pl-2 pr-2 hover:bg-[#db0a41] cursor-pointer rounded-md data-active:bg-hyper-red data-active:text-white"
                      onClick={() => {
                        setSelectedItem(item);
                      }}
                    >
                      <div className="w-[22px]">{item.icon}</div>
                      {item?.name}
                    </li>
                  );
                })}
            </ul>
          </div>
          <div className="p-2 flex flex-col">
            {selectedItem?.name}
            {selectedItem?.type !== "TABS" && (
              <Input
                label="Label"
                value={selectedItem?.label ?? selectedItem?.name}
                onChange={(e) => {
                  setSelectedItem({ ...selectedItem, label: e });
                }}
                onInputRightClick={(e) => {}}
              />
            )}
            <div className="flex w-full flex-col">
              {selectedItem?.type === "TABS" && (
                <>
                  <button
                    type="button"
                    onClick={() => {
                      let tab = { ...selectedItem };
                      tab.tabs.push({ label: "" });
                      setSelectedItem(tab);
                    }}
                    className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                    + Add tab
                  </button>
                  {selectedItem.tabs.map((tab, index) => {
                    return (
                      <Input
                        value={tab?.label}
                        onChange={(e) => {
                          let tab = { ...selectedItem };
                          tab.tabs[index].label = e;
                          setSelectedItem(tab);
                        }}
                        onInputRightClick={(e) => {}}
                      />
                    );
                  })}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="mt-5 sm:mt-6">
          <button
            type="button"
            onClick={() => {
              onSave({
                selectedItem,
              });
            }}
            className="inline-flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Save
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default Components;
